import { render } from "./MyActivities.vue?vue&type=template&id=167de791&scoped=true"
import script from "./MyActivities.vue?vue&type=script&lang=js"
export * from "./MyActivities.vue?vue&type=script&lang=js"

import "./MyActivities.vue?vue&type=style&index=0&id=167de791&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167de791"]])

export default __exports__